/**
 * Reflows given elements.
 * [MDN Glossary: Reflow]{@link https://developer.mozilla.org/en-US/docs/Glossary/Reflow}
 * [Repaints and Reflows: Manipulating the DOM responsibly]{@link https://sites.google.com/site/getsnippet/javascript/dom/repaints-and-reflows-manipulating-the-dom-responsibly}
 */
export default function reflow() {
  window.getComputedStyle(document.body)
}
